import * as patientType from "../../actiontype/PatientType/PatientType";

import { get,post,put,deleteReq } from "../../../../common/utils/index.js";
import { onCommonReducerPatientData } from "../CommonAction/Common.jsx";
import { PATIENTGETIDCOMMON } from "../../actiontype/CommonType/CommonType.jsx";

export const createPatient= (payload,showLoader,hideLoader,setIsSuccess,showToast,dataTrans,setIsPopup) => (dispatch) => {
    showLoader();
    dispatch({ type: patientType.PATIENT_REQUEST })
    post('Patient/Register',payload)
        .then(res => {
            dispatch({ type: patientType.PATIENT_SUCCESS, payload: res })
            setIsPopup("");
            setIsSuccess(true);
            hideLoader();
            var headers={ 
                pageNo:1,
                pageSize:10,
              }
            dispatch(getPatientList(headers,showLoader,hideLoader));
            showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
        })
        .catch(err => {
         hideLoader();
         dispatch({ type: patientType.PATIENT_FAILURE, payload:err?.response?.data?.message})
         showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
        })
}

export const getPatientList= (headers,showLoader,hideLoader) => (dispatch) => {
    showLoader();
    dispatch({ type: patientType.PATIENT_REQUEST_LIST })
    get('Patient',headers)
        .then(res => {
            dispatch({ type: patientType.PATIENT_SUCCESS_LIST, payload: res?.data })
            hideLoader();
        })
        .catch(err => {
         hideLoader();
         dispatch({ type: patientType.PATIENT_FAILURE_LIST, payload:err?.response?.data?.message})
        })
}

export const createPatientRegister= (payload,showLoader,hideLoader,setIsSuccess,showToast,dataTrans,setIsPopup) => (dispatch) => {
    showLoader();
    dispatch({ type: patientType.PATIENT_REQUEST })
    post('Patient',payload)
        .then(res => {
            dispatch({ type: patientType.PATIENT_SUCCESS, payload: res })
            setIsPopup("")
            setIsSuccess(true);
            hideLoader();
            var headers={ 
                pageNo:1,
                pageSize:10,
              }
            dispatch(getPatientList(headers,showLoader,hideLoader));
            showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
        })
        .catch(err => {
         hideLoader();
         dispatch({ type: patientType.PATIENT_FAILURE, payload:err?.response?.data?.message})
         showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
        })
}

export const getByPatientId= (id,showLoader,hideLoader,showToast,dataTrans) => (dispatch) => {
    showLoader();
    dispatch({ type: patientType.PATIENT_REQUEST_GETBYID })
    get(`Patient/${id}`)
        .then(res => {
            dispatch({ type: patientType.PATIENT_SUCCESS_GETBYID, payload: res?.data })
            hideLoader();
            // var headers={ 
            //     pageNo:1,
            //     pageSize:10,
            
            //   }
            // dispatch(getPatientList(headers,showLoader,hideLoader));
            dispatch(onCommonReducerPatientData(res.data,PATIENTGETIDCOMMON))
        })
        .catch(err => {
         hideLoader();
         dispatch({ type: patientType.PATIENT_FAILURE_GETBYID, payload:err?.response?.data?.message})
         showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
        })
}
// object wise construction
export const updatePatient = (id,payload,showLoader,hideLoader,setFlage,showToast,dataTrans,viewRoleId) => (dispatch) => {

    showLoader();
    dispatch({ type: patientType.PATIENT_REQUEST_UPDATE })
   
    put(`/Patient/${id}`,payload)
      .then(res => {
        hideLoader();
        dispatch({ type: patientType.PATIENT_SUCCESS_UPDATE, payload: res.data })
        dispatch(getByPatientId(viewRoleId,showLoader,hideLoader))
        showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
        setFlage(false)
        // dispatch(AdminPPList(headers,showLoader,hideLoader));
      })
      .catch(err => {
        hideLoader();
        dispatch({ type: patientType.PATIENT_FAILURE_UPDATE, payload: err?.message })
        showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
      })
  }



export const deletePatient= (id,showLoader,hideLoader,showToast,dataTrans) => (dispatch) => {
    showLoader();
    dispatch({ type: patientType.PATIENT_REQUEST_DELETE })
    deleteReq(`Patient/${id}`)
        .then(res => {
            dispatch({ type: patientType.PATIENT_SUCCESS_DELETE, payload: res })
            hideLoader();
            var headers={ 
                pageNo:1,
                pageSize:10,
              }
            dispatch(getPatientList(headers,showLoader,hideLoader));
            // showToast("success", "Successo", "Record eliminato con successo");//changes 168 bug
            showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
        })
        .catch(err => {
         hideLoader();
         dispatch({ type: patientType.PATIENT_FAILURE_DELETE, payload:err?.response?.data?.message})
         showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
        })
}

export const updateStatusPatient = (id, payload, header, showLoader, hideLoader, showToast,dataTrans) => (dispatch) => {

    showLoader();
    dispatch({ type: patientType.PATIENT_REQUEST_UPDATE })
  
    put(`/Patient/UpdateStatus/${id}`, payload, header)
      .then(res => {
        hideLoader();
        dispatch({ type: patientType.PATIENT_SUCCESS_UPDATE, payload: res.data })
        var headers = {
          pageNo: 1,
          pageSize: 10,
        }
        dispatch(getPatientList(headers, showLoader, hideLoader));
        // dispatch(getByPatientId(id, showLoader, hideLoader))
        showToast('success',dataTrans('text_toast_success'),res?.response?.data?.message);
      })
      .catch(err => {
        hideLoader();
        dispatch({ type: patientType.PATIENT_FAILURE_UPDATE, payload: err?.message })
        showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
      })
  }